'use client';

import { type VariantProps } from 'class-variance-authority';
import { chipVariants } from './chipVariants';
import { cn } from '../../utils/cn/cn';

export interface ChipProps extends VariantProps<typeof chipVariants> {
  className?: string;
  disabled?: boolean;
  iconClassname?: string;
  iconPosition?: 'start' | 'end' | 'double';
  label: string;
  onClick?: () => void;
  onDelete?: () => void;
}

const Chip = ({
  className,
  color,
  disabled,
  iconClassname,
  iconPosition,
  label,
  onClick,
  onDelete,
  selected,
  size,
  variant,
  ...props
}: ChipProps) => (
  <div
    className={cn(
      chipVariants({
        className,
        color,
        disabled,
        selected,
        size,
        variant,
      }),
    )}
    role="button"
    tabIndex={0}
    {...(!disabled &&
      typeof onClick === 'function' && {
        onClick,
        onKeyDown: (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick();
          }
        },
      })}
    {...props}
  >
    {iconClassname &&
      iconClassname !== '' &&
      (iconPosition === 'start' || iconPosition === 'double') && (
        <span className={`${iconClassname}`} />
      )}
    <span className="px-1 pt-[1px]">{label}</span>
    {iconClassname &&
      iconClassname !== '' &&
      (iconPosition === 'end' || iconPosition === 'double') && (
        <span className={`${iconClassname}`} />
      )}
    {onDelete && (
      <div
        className={`m-0 inline-flex items-center justify-center p-0 ${!disabled ? 'hover:cursor-pointer' : ''}`}
        {...(!disabled &&
          typeof onDelete === 'function' && {
            onClick: onDelete,
            onKeyDown: (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onDelete();
              }
            },
          })}
        role="button"
        tabIndex={0}
        aria-hidden="true"
      >
        <span className="icon-emp-clear-input" />
      </div>
    )}
  </div>
);

Chip.displayName = 'Chip';

export { Chip };
